<div *ngIf="form">
  <form (ngSubmit)="onSubmit()" [formGroup]="form">
    <div class="d-flex row justify-content-md-center">
      <div class="col-md-12">
        <div class="row">
          <!--First display all non table controls (with col-6)-->
          <ng-container *ngFor="let control of controls">
            <div *ngIf="control.viewState!=='Invisible' && control.viewState!=='NotSorrento' && control.controlType !== 'table'" class="col-md-6 mb-1">
              <app-dynamic-form-control [control]="control" [form]="form"
                (selectedControl)="receiveSelectedControl($event)" (addRow)="rowAdd($event)"
                (removeRow)="rowRemove($event)" (rowOrderChanged)="changeRowOrder($event)"
                (valueAutoCompleted)="onValueAutoComplete($event)"></app-dynamic-form-control>
            </div>
          </ng-container>
          <!--Then display all tables (with col-12)-->
          <ng-container *ngFor="let control of controls">
            <div *ngIf="control.viewState!=='Invisible' && control.viewState!=='NotSorrento' && control.controlType === 'table'" class="col-md-12 mb-1">
              <app-dynamic-form-control [control]="control" [form]="form"
                (selectedControl)="receiveSelectedControl($event)" (addRow)="rowAdd($event)"
                (removeRow)="rowRemove($event)" (rowOrderChanged)="changeRowOrder($event)"
                (valueAutoCompleted)="onValueAutoComplete($event)"></app-dynamic-form-control>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
    <div>

      <div class="d-flex justify-content-between mt-4" *ngIf="validValueSet===true">
        <div>
          <a mat-stroked-button (click)="onBackClick()">{{'Back' | translate}}</a>
        </div>
        <div matTooltip="{{'Metadata.BeforeConfirm'| translate}}" matTooltipPosition="above"
          [matTooltipDisabled]="caseItemStatus==='Confirmed' || caseItemStatus === 'Processed' || caseItemStatus==='Closed' || isMainCaseItem === false"
          matTooltipClass="font-size">
          <button mat-flat-button color="accent" type="submit" class="text-white"
            [disabled]="!form.valid || caseItemStatus === 'Confirmed' || caseItemStatus === 'Processed' || caseItemStatus === 'Closed'">{{ 'Confirm' | translate }}</button>
        </div>
      </div>
    </div>
  </form>
</div>
